import { TradingOffer, TradingOfferStatus } from '../../../types/TradingOffer';

export const getOfferStatus = (offer: TradingOffer): TradingOfferStatus => {
  const now = new Date();
  const endDate = new Date(offer.endDate);

  if (endDate < now) {
    return 'EXPIRED';
  }

  if (offer.sharesCount.agreed === offer.sharesCount.total) {
    return 'ACCEPTED';
  }

  return 'ACTIVE';
};

export const isOfferExpired = (offer: TradingOffer): boolean => {
  const status = getOfferStatus(offer);
  return status === 'EXPIRED';
};

export const isOfferAccepted = (offer: TradingOffer): boolean => {
  const status = getOfferStatus(offer);
  return status === 'ACCEPTED';
};

export const isOfferActive = (offer: TradingOffer): boolean => {
  const status = getOfferStatus(offer);
  return status === 'ACTIVE';
};
